<template>
  <div class="task-status-form" :class="modalTheme" >
    <div class="d-flex flex-column">
      <!-- <h4  class="text-center pb-2 position-sticky">Patient Tasks Status FORM</h4> -->

      <!-- <div hidden style="background-color: darkgrey; color: green"> -->
      <!-- <h4>statusData</h4> -->
      <!-- <h6 style="background-color:black;color:cyan">statusComments {{ statusData.statusComments.length }}</h6>
				<h6 style="background-color:black;color:red">statusOptions {{ statusData.statusOptions.length }}</h6>
        <h6 style="background-color:black;color:orange">status :{{ statusData.status }}</h6>
				<h6 style="background-color:black;color:lime">status :{{ statusData.status }}</h6> -->
      <!-- </div> -->

      <!-- <div hidden style="background-color: black; color: orange"> -->
      <!-- <h5 style="background-color:darkred;color:magenta">form.statusSelection {{ form.statusSelection }}</h5>
				<h6 style="background-color:darkblue;color:cyan">form.statusOPT {{ form.statusOptions }}</h6>

				<h6 hidden style="background-color:darkblue;color:red">statusOptions {{ statusData.statusOptions.length }}</h6>
				<h6 hidden style="background-color:darkblue;color:orange">status selection: {{ statusData.status }}</h6>

				<h6 hidden :click="bindStatus" style="color:lime">incomingStatus: {{ incomingStatus }}</h6> -->
      <!-- </div> -->

      <!-- statusData.statusComments: {{statusData.statusComments.length}}
			statusCommentsArray: {{statusCommentsArray.length}}-->

      <div class="patient-status">
        <div class="d-flex flex-column">
          <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
            <b-form-group id="input-group-3" label="Status Selection:" label-for="input-3">
              <!-- <span hidden>id : {{ this.form.rowId }}</span> -->

              <b-form-select :class="modalTheme" id="input-3" v-model="form.statusSelection" :options="form.statusOptions" value-field="statusName" text-field="statusName" required></b-form-select>
              <div>
                <br />
                <label>Comment:</label>
                <b-form-textarea id="statusComment" v-model="form.currentComment" placeholder="Enter a Comment for the Status change" rows="3" max-rows="6" required></b-form-textarea>
                <br />
                <div class="btnsContainer ml-6">
                  <b-row>
                    <b-col>
                      <b-button size="sm" :class="modalTheme" type="reset" variant="primary-green">Reset</b-button>
                    </b-col>
                    <b-col>
                      <b-button size="sm" :class="modalTheme" type="submit" variant="primary-green">Submit</b-button>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <!-- <div>
                <status-comment class="comment-box" v-for="sComment in form.statusComments" :comment="sComment" :key="sComment.commentId" />
              </div> -->
            </b-form-group>
          </b-form>

          <b-card hidden class="mt-3" variant="danger" header="Form Data Result">
            <pre class="m-0">{{ form }}</pre>
          </b-card>
        </div>
        <!-- <div class="d-flex mt-3">
						<div class="ml-auto patient-note-buttons">
							<b-button class="mr-3" type="submit" variant="primary">Submit</b-button>
							<b-button type="reset" variant="danger">Cancel</b-button>
						</div>
				</div> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
// * STORE
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
// * STOREs
import { usePatientStore } from "@/stores/patientStore";
const patientStore = usePatientStore();
import StatusCommentForm from "@/modules/Patient/StatusCommentForm.vue";

// & PROPS
const props = defineProps({
  personId: {
    Type: String,
    Default: () => {},
  },
  statusData: {
    Type: Object,
    Default: () => {},
  },
});
const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(true);
const modalShow = ref(true);
const showStatusForm = ref(true);
const showReAssignForm = ref(true);

const form = ref({
  rowId: props.statusData.id,
  statusSelection: props.statusData.status,
  currentComment: "",
  statusOptions: props.statusData.statusOptions,
  statusComments: props.statusData.statusComments,
});

// * EMITTER
const emit = defineEmits(["put-TaskStatus", "close-modal"]);

function onSubmit() {
  // if (this.currentComment.length >= 4000) {
  // 	toastrError('The maximum size of the note is 4000 characters')
  // 	return
  // }
  // if (this.currentComment.length < 5) {
  // 	toastrError('A comment should be at least 5 characters')
  // 	return
  // }
  // this.statusComments.push(this.currentComment)

  // console.log(" ^^^^^^^  FORM SUBMITTAL ^^^^^^^^^^^^^");
  // console.log();
  // console.log(form.value.rowId);
  // console.log();
  // console.log(form.value.statusSelection);
  // console.log();
  // console.log(form.value.currentComment);

  // console.log("PAYLOAD CHECCK >>>>>>>>>>>>>>");

  // console.log(" form.value.rowId", form.value.rowId);
  // console.log("   props.personId,", props.personId);
  // console.log(" form.value.statusSelection", form.value.statusSelection);
  // console.log(" form.value.currentComment", form.value.currentComment);
  // console.log(" form.value.statusComments", form.value.statusComments);
  // console.log(" form.value.statusOptions", form.value.statusOptions);

  // console.log("PersonId", patientStore.currentPatientId);

  const postPAYLOAD = {
    // action: TaskActions.Status,
    Id: form.value.rowId,
    // CommentId: "",
    Comment: form.value.currentComment,
    PersonId: props.personId,
    Status: form.value.statusSelection,
  };
  // console.log(" postPAYLOAD PAYLOAD >>>>>>>>>>>>>>", postPAYLOAD);

  emit("put-TaskStatus", postPAYLOAD);
  // console.log(" EMITTER put-TaskStatus >>>>>>>>>>>>>>", postPAYLOAD);

  // emit("put-TaskStatus", {
  //   id: this.form.rowId,
  //   statusSelection: this.form.statusSelection,
  //   text: this.form.currentComment,
  // });

  // onReset();
}

function onReset() {
  form.value.currentComment = "";
  form.value.statusSelection = props.statusData.status;

  showStatusForm.value = !showStatusForm.value;
  // console.log(showStatusForm);
  // this.$emit("close-modal");
  emit("close-modal");
}

onMounted(() => {
  // console.clear();
  // console.log("onMounted() :      PATIENT TASK  STATUS FORM  >>>>");
  // console.log(" prop   statusData ");
  // console.log("props : ");
  // console.log(props);
  // console.log(props.statusData);
});
</script>

<style lang="scss" scoped>
.task-status-form {
  text-align: initial; // need this because the dx-toolbar text-align: center was causing problems with the labels
  //  background-color: #849185; //#b0c1b2 !important;
  //  color: #ebebeb;
  padding-left: 15px;
  padding-top: 15px;
  padding-right: 15px;
  padding-bottom: 0px;
}

.comments-list {
  list-style: none;

  .comment {
    padding: 0.5rem 0;
    word-wrap: break-word;
    white-space: pre-wrap; // this is so we don't have to use pre
  }

  .comment-text {
    font: inherit;
    font-size: 0.75em;
  }

  .comment-date {
    font-size: 0.75em;
    font-weight: 800;
    padding-bottom: 0.5rem;
    color: #123486;
  }
}

.existing-comment {
  //  background: primary-light-gray;
  margin: 2rem;
  padding: 1rem;
  border-radius: 1rem;
  width: 100%;
  overflow-y: auto;
  max-height: 50vh;
}

.patient-comment {
  padding-top: 1rem;
  width: 100%;
  margin: 0 auto;

  &-textarea {
    display: block;
    height: 6rem;
    // margin: 0 auto;
    // width: 80%;
  }

  .task-form {
    margin-top: 1rem;
    height: 8rem;
  }
}

.btnsContainer {
  display: flex;
  justify-content: flex-end;
}

.btn-primary-green {
  border: none;
  text-decoration: none;
  color: #fcfefc;
  background-color: #b0c1b2;
}

.btn-primary-green:hover {
  background-color: #caeacd;
  color: #123486;
  border-radius: 0px 0px 0px 0px;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1;
  border-radius: 0.2rem;
  background: #eef8ef;
}
</style>
